import astrochimp from 'astrochimp'

const newsletter = (() => {
    const EMAIL_FORM_SELECTOR = '.js-newsletterForm'

    function onFormSignup(e) {
        e.preventDefault();
            
        let form = e.currentTarget;
        let success = form.nextElementSibling;
        const email = form.elements.email

        // console.log(email.value)
        // console.log(success)

        astrochimp('https://paulinwatches.us9.list-manage.com/subscribe/post?u=fcf455ee34b97da4d93c73af5&amp;id=95862e90c8&amp;f_id=00260fe1f0', {
            EMAIL: email.value
        }, (err, data) => {
            console.log('success?', err, data)
            if (!err) {
            
            form.reset()
            form.classList.add('hidden')
            success.classList.remove('hidden')
            }
        })
    }

    function bind() {
        const emailForms = document.querySelectorAll(EMAIL_FORM_SELECTOR)
        Array.prototype.forEach.call(emailForms, (form) => {
            form.removeEventListener("submit", onFormSignup);
            form.addEventListener("submit", onFormSignup);
        });
    }

    function init() {
        bind();
    }

  return {
    init
  };
})();

export default newsletter;